module.exports = __webpack_public_path__ + "static/media/scrollToTop.29bb99d5.svg";